const REQUIRED_KEYS = ['VITE_GH_CLIENT_ID'];

/**
 * Builds a frozen env object from a source map (usually `import.meta.env`).
 * Exported for direct testing — validates required keys and provides defaults.
 *
 * VITE_BACKEND_URL is optional:
 *   - unset / empty / '/' → requests go same-origin (useful for local dev
 *     where Vite's proxy forwards /api/* to the real backend)
 *   - absolute URL       → requests target that origin directly
 */
export function buildEnv(source) {
  for (const key of REQUIRED_KEYS) {
    if (!source[key]) {
      throw new Error(`Missing required env: ${key}`);
    }
  }
  const raw = (source.VITE_BACKEND_URL ?? '').trim();
  const backendUrl = raw === '' || raw === '/' ? '/' : raw.replace(/\/$/, '') + '/';

  return Object.freeze({
    ENVIRONMENT: source.VITE_ENVIRONMENT ?? 'dev',
    BACKEND_URL: backendUrl,
    GH_CLIENT_ID: source.VITE_GH_CLIENT_ID,
    GH_CIRUN_APP_NAME: source.VITE_GH_CIRUN_APP_NAME ?? 'cirun-development',
    SENTRY_DSN: source.VITE_SENTRY_DSN ?? null,
  });
}

export const env = buildEnv(import.meta.env);
